<bpc-widget [title]="title" [filters]="filters" (onFilterChange)="onFilterChange($event)">
  <div class="chart-container">
    <bpc-highchart [chartOptions]="chartOptions"  *ngIf="!loading && data > 0" />
      <bpc-dynamic-skeleton-loader [numberOfSkeletons]="loaders" *ngIf="loading"></bpc-dynamic-skeleton-loader>
      <div *ngIf="!loading && data === 0" class="no-data">
        <h2>No data available</h2>
      </div>
  </div>
</bpc-widget>
